import React from 'react';
import ContentLoader from 'react-content-loader';

const ExpandedPoiCardSkeleton = () => {
    return (
        <ContentLoader
            uniqueKey="expanded-poi-card-skeleton"
            speed={2}
            width={800}
            height={400}
            viewBox="0 0 800 400"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            className="max-w-full"
        >
            <rect x="28" y="29" rx="2" ry="2" width="309" height="309" />
            <circle cx="395" cy="62" r="31" />
            <rect x="442" y="35" rx="0" ry="0" width="165" height="25" />
            <rect x="444" y="72" rx="0" ry="0" width="136" height="12" />
            <rect x="368" y="128" rx="0" ry="0" width="238" height="205" />
        </ContentLoader>
    );
};

export default ExpandedPoiCardSkeleton;
